import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as VerifyAccountIcon } from 'assets/icons/verify-account.svg';
import authService from 'services/auth.service';
import { ROUTE_KEYS } from 'utils/constants';
import AuthLayout from 'pages/auth/auth-layout';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const verifyToken = async () => {
    try {
      const response = await authService.confirmEmail({ token });
      if (response?.status === 201) {
        setSuccess(true);
        navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}?from=verify-email`);
      } else {
        setSuccess(false);
        setError('Email verification failed');
      }
    } catch (err: any) {
      setSuccess(false);
      setError(err?.response?.data?.message || 'An error occured');
    } finally {
      setLoading(false);
    }
  };

  const routeToLogin = () =>
    success
      ? navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}?from=verify-email`)
      : navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`);

  useEffect(() => {
    localStorage.clear();
    if (token) verifyToken();
  }, [token]);
  return (
    <div>
      <AuthLayout
        title='Confirm New Email'
        onConfirmText={success ? 'Continue to Login' : 'Back to Login'}
        onConfirm={routeToLogin}
        hideButton={loading}>
        <div className='mx-auto'>
          <VerifyAccountIcon className='mb-8' />
          {loading ? (
            <p className='text-[#6F7376] max-mb-[80px] text-center'>
              Verifying your new email address...
            </p>
          ) : success ? (
            <p className='text-[#6F7376] max-mb-[80px] text-center'>
              Your new email has been verified successfully
            </p>
          ) : (
            <p className='text-[#6F7376] max-mb-[80px] text-center'>{error}</p>
          )}
        </div>
      </AuthLayout>
    </div>
  );
};

export default VerifyEmail;
